import { render, staticRenderFns } from "./art-image-map.vue?vue&type=template&id=1ad0a4b2&scoped=true&"
import script from "./art-image-map.vue?vue&type=script&lang=js&"
export * from "./art-image-map.vue?vue&type=script&lang=js&"
import style0 from "./art-image-map.vue?vue&type=style&index=0&id=1ad0a4b2&scoped=true&style=scss&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0a4b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FullScreenImage: require('/home/martin/web/decentral-art/components/full-screen-image.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
